import api from "./base-api"


const mcChargeApi = api.injectEndpoints({
    endpoints: (build) => ({
        getGuidMapMC: build.query({
            query: () => `v2/mc/states/guid-map`
        }),
        getChargesMC: build.query({
            query: (userId = "") => `v2/mc/charges/${userId}`,
            providesTags: ['Charges']
        }),
        createChargeMC: build.mutation({
            query: (body = {}) => ({
                url: `v2/mc/charges`,
                method: "POST",
                body: body
            }),
            invalidatesTags: ['Charges', 'MCChargerLogsById', 'MCChargerLogs'],
        }),
        createMassChargeMC: build.mutation({
            query: (body = new FormData()) => ({
                url: `v2/mc/charges`,
                method: "POST",
                body: body
            })
        }),
        dischargeMC: build.mutation({
            query: (body = []) => ({
                url: `v2/mc/charges/discharge`,
                method: "PUT",
                body: body
            })
        })
    }),
    overrideExisting: false
})

export const selectGuidMapMC = (state) => api.endpoints.getGuidMapMC.select()(state).data


export const {
    useGetGuidMapMCQuery,
    useGetChargesMCQuery,
    useCreateChargeMCMutation,
    useCreateMassChargeMCQuery
} = mcChargeApi
